import { ListResponseModel, PasswordQuery, QueryParamModel, UserModel } from 'models';
import request, { Methods, requestFile } from 'utils/request';
import { EntityService } from 'utils/entityService';
import { exportFile } from 'utils/exportFile';
import { Mock } from 'utils/mockDecorator';
import { mockListResponse } from 'mock/list';

class UserService extends EntityService {
  constructor() {
    super('user');
  }

  async validateToken(data: PasswordQuery) {
    return request<any>({
      resource: `${this.resource}/validate-token`,
      params: {
        email: data.email,
        token: data.token,
        lang: data.lang,
      },
    });
  }

  @Mock(() => import('mock/users').then((m) => m.MOCK_USER_LIST))
  async getUserListSearch(params?: QueryParamModel | null) {
    return request<UserModel[]>({
      method: Methods.GET,
      resource: `${this.resource}/search`,
      params,
    });
  }

  @Mock((params: QueryParamModel) =>
    import('mock/users').then((m) => mockListResponse(m.MOCK_USER_LIST, params))
  )
  async getUserList(params?: QueryParamModel | null) {
    return request<ListResponseModel<UserModel>>({
      method: Methods.GET,
      resource: this.resource,
      params,
    });
  }

  async exportUsers(params?: QueryParamModel | null) {
    const response = await requestFile<BlobPart>({
      method: Methods.GET,
      resource: `${this.resource}/export`,
      params,
    });

    await exportFile(response, 'felhasznalok.xlsx');

    // Deliberately not returning the payload: react-query would hold the whole XLSX ArrayBuffer in
    // its cache for the lifetime of the observing page, once per distinct export param set.
    return true;
  }

  async editUser(data: Partial<UserModel>[]) {
    return request<UserModel[]>({
      method: Methods.POST,
      resource: this.resource,
      data,
    });
  }

  async deleteUser(id: ID) {
    return request<void>({
      method: Methods.DELETE,
      resource: `${this.resource}/${id}`,
    });
  }
}

export const userService = new UserService();
